<template>
  <div class="dashboard-sidebar">
    <div class="mb10">
      <div class="text-bold text-red mb10">Date Range</div>
      <div class="flex-space-between">
        <button :class="`btn-va btn-va-wrapper${$store.state.vaStore.date_range == 3
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedDateRange(3)">
          3 Bulan
        </button>
        <button :class="` btn-va btn-va-wrapper${$store.state.vaStore.date_range == 6
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedDateRange(6)">
          6 Bulan
        </button>
        <button :class="` btn-va btn-va-wrapper${$store.state.vaStore.date_range == 12
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedDateRange(12)">
          12 Bulan
        </button>
      </div>
    </div>

    <div class="mb30">
      <div class="flex-space-between">
        <div class="range-picker-container">
          <div class="mr10">Custom</div>
          <date-range-picker v-model="dateRange" opens="right" :timePicker="false" :linked-calendars="false" :ranges="{
            Today: [today, today],
            Yesterday: [yesterday, today],
            'Last 7 days': [weekBefore, today],
            'Last 30 days': [monthBefore, today],
            // 'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
            'Last 90 days': [threeMonthBefore, today],
            'Last 120 days': [fourMonthBefore, today],
            'This year': [new Date(today.getFullYear(), 0, 1), today],
            'This Quarter 1 (Jan - Mar)': [
              new Date(today.getFullYear(), 0, 1),
              new Date(today.getFullYear(), 2, 31),
            ],
            'This Quarter 2 (Apr - Jun)': [
              new Date(today.getFullYear(), 3, 1),
              new Date(today.getFullYear(), 5, 30),
            ],
            'This Quarter 3 (Jul - Sep)': [
              new Date(today.getFullYear(), 6, 1),
              new Date(today.getFullYear(), 8, 30),
            ],
            'This Quarter 4 (Okt - Des)': [
              new Date(today.getFullYear(), 9, 1),
              new Date(today.getFullYear(), 11, 31),
            ],
            'This Semester 1 (Jan - Jun)': [
              new Date(today.getFullYear(), 0, 1),
              new Date(today.getFullYear(), 5, 30),
            ],
            'This Semester 2 (Jul - Des)': [
              new Date(today.getFullYear(), 6, 1),
              new Date(today.getFullYear(), 11, 31),
            ],
            'Last 2 Years': [dateRange.startDate, dateRange.endDate],
            'Last 3 Years': [lastThreeYears.last3, lastThreeYears.endDate],
          }" control-container-class="col-lg-6 col-xl-7 col-elipsis all-column bg-secondary pointer">
            <!--    header slot-->
            <div slot="header" slot-scope="header" class="slot">
              <h3>Custom Date</h3>
              <span v-if="header.in_selection"> - in selection</span>
            </div>
            <!--    input slot (new slot syntax)-->
            <template #input="picker" style="min-width: 350px;">
              {{ formatNumberDate(picker.startDate) | date }} -
              {{ formatNumberDate(picker.endDate) | date }}
            </template>
            <!--    date slot-->
            <template #date="data">
              <span class="small">{{ data.date | dateCell }}</span>
            </template>
            <!--    ranges (new slot syntax) -->
            <template #ranges="ranges" class="calendar-container">
              <div class="ranges">
                <ul>
                  <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                    <b>{{ name }}</b>
                    <small class="text-muted">{{ range[0].toDateString() }} -
                      {{ range[1].toDateString() }}</small>
                  </li>
                </ul>
              </div>
            </template>
            <!--    footer slot-->
            <div slot="footer" slot-scope="data" class="slot">
              <div style="margin-left: auto">
                <a @click="data.clickCancel" v-if="!data.in_selection" class="btn btn-primary btn-sm mr10">Cancel</a>
                <a @click="data.clickApply" v-if="!data.in_selection" class="btn btn-primary btn-sm">Apply</a>
              </div>
            </div>
          </date-range-picker>
        </div>
      </div>
    </div>

    <div class="mb10">
      <div class="text-bold text-red mb10">Company</div>
      <div class="flex-space-between mb10">
        <button :class="`btn-va btn-va-wrapper${$store.state.vaStore.bisnis_unit == 'BCE'
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedBisnisUnit('BCE')">
          BCE
        </button>
        <button :class="`btn-va btn-va-wrapper${$store.state.vaStore.bisnis_unit == 'GEMS'
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedBisnisUnit('GEMS')">
          GEMS
        </button>
        <button :class="`btn-va btn-va-wrapper${$store.state.vaStore.bisnis_unit == 'BKES'
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedBisnisUnit('BKES')">
          BKES
        </button>
      </div>
      <div class="mb10" style="width: 100%;">
        <div>Custom</div>
        <!-- <select 
          style="width: 60%;"
          v-model="customCode"
        >
          <option :value="''">Choose Company</option>
          <option v-for="(list) in company_options" :value="list.id">
            {{ list.label }}
          </option>
        </select> -->
        <treeselect :multiple="true" :options="company_options" placeholder="Select Company..." v-model="customCode" />
      </div>
    </div>

    <div class="mb10">
      <div class="text-bold text-red mb10">Region</div>
      <div class="mb10" style="display:flex;width: 100%;justify-content: space-between;">
        <treeselect :multiple="true" :options="regions" placeholder="Select Region..." v-model="choosedRegion" />
      </div>
    </div>

    <div class="mb10">
      <div class="text-bold text-red mb10">Kegiatan Usaha Utama</div>
      <div class="mb10" style="display:flex;width: 100%;justify-content: space-between;">
        <treeselect :multiple="true" :options="kbliList" placeholder="Select KBLI..." v-model="choosedKbli" />
      </div>
    </div>

    <div class="mb10">
      <div class="text-bold text-red mb10">Afiliasi</div>
      <div class="flex-space-between">
        <button :class="` btn-va btn-va-wrapper${$store.state.vaStore.afiliasi == 'all'
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedAfiliasi('all')">
          All
        </button>
        <button :class="` btn-va btn-va-wrapper${$store.state.vaStore.afiliasi == 'ya'
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedAfiliasi('ya')">
          Ya
        </button>
        <button :class="` btn-va btn-va-wrapper${$store.state.vaStore.afiliasi == 'tidak'
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedAfiliasi('tidak')">
          Tidak
        </button>
      </div>
    </div>

    <div class="mb10">
      <div class="text-bold text-red mb10">SIO</div>
      <div class="flex-space-between">
        <button :class="` btn-va btn-va-wrapper${$store.state.vaStore.sio == 'all' ? '__red' : '__transparent-red'
          } text-ssm`
          " @click="choosedSIO('all')">
          All
        </button>
        <button :class="` btn-va btn-va-wrapper${$store.state.vaStore.sio == 'ya' ? '__red' : '__transparent-red'
          } text-ssm`
          " @click="choosedSIO('ya')">
          Ya
        </button>
        <button :class="` btn-va btn-va-wrapper${$store.state.vaStore.sio == 'tidak'
          ? '__red'
          : '__transparent-red'
          } text-ssm`
          " @click="choosedSIO('tidak')">
          Tidak
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import axios from 'axios'
import { api } from '@/services/config'

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    DateRangePicker,
    Treeselect,
  },
  data() {
    let endDate = new Date()
    let startDate = new Date()
    startDate.setFullYear(startDate.getFullYear() - 2)

    let last3 = new Date()
    last3.setFullYear(last3.getFullYear() - 3)

    let thisDay = new Date()
    thisDay.setHours(0, 0, 0, 0)

    let dayBefore = new Date()
    dayBefore.setDate(thisDay.getDate() - 1)
    dayBefore.setHours(0, 0, 0, 0)

    let weekBefore = new Date()
    weekBefore.setDate(thisDay.getDate() - 7)

    let monthBefore = new Date()
    monthBefore.setDate(thisDay.getDate() - 30)

    let threeMonthBefore = new Date()
    threeMonthBefore.setDate(thisDay.getDate() - 90)

    let fourMonthBefore = new Date()
    fourMonthBefore.setDate(thisDay.getDate() - 120)
    return {
      dateRange: { startDate, endDate },
      today: thisDay,
      yesterday: dayBefore,
      weekBefore: weekBefore,
      monthBefore: monthBefore,
      threeMonthBefore: threeMonthBefore,
      fourMonthBefore: fourMonthBefore,
      lastThreeYears: { last3, endDate },
      //multiple select
      gemsValue: null,
      gemsOptions: [],
      bcValue: null,
      bcOptions: [],
      company_options: [],
      customCode: null,
      regions: [],
      choosedRegion: null,
      kbliList: [],
      choosedKbli: null,
    }
  },
  filters: {
    dateCell(value) {
      let dt = new Date(value)

      return dt.getDate()
    },
    date(val) {
      return val ? val.toLocaleString() : ''
    },
  },
  async created() {
    await this.getRegion()
    await this.getKbli()
  },
  watch: {
    async dateRange(value) {
      let startDate = moment(value.startDate).format('YYYY-MM-DD')
      let endDate = moment(value.endDate).format('YYYY-MM-DD')

      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'date_range',
        value: 0,
      })
      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'start',
        value: startDate,
      })
      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'end',
        value: endDate,
      })

      await this.$store.dispatch('vaStore/filterDate')
    },
    async bcValue(value) {
      this.gemsValue = null

      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'bisnis_unit',
        value,
      })
    },
    async gemsValue(value) {
      this.bcValue = null
      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'bisnis_unit',
        value,
      })
    },
    async customCode(value) {
      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'company_code',
        value,
      })

      await this.$store.dispatch('vaStore/allFilter')
    },
    async choosedKbli(value) {
      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'kbli',
        value,
      })

      await this.$store.dispatch('vaStore/allFilter')
    },
    async choosedRegion(value) {
      await this.$store.commit('vaStore/UPDATE_DATA', {
        name: 'region',
        value,
      })

      await this.$store.dispatch('vaStore/allFilter')
    },
  },
  methods: {
    async choosedDateRange(value) {
      let thisday = new Date()
      thisday.setHours(0, 0, 0, 0)
      let monthBefore = new Date()

      let date_range = this.$store.state.vaStore.date_range

      if (value == date_range) {
        monthBefore = moment(new Date()).subtract(3, 'months')
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'date_range',
          value: 3,
        })
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'start',
          value: '',
        })
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'end',
          value: '',
        })
      } else {
        switch (value) {
          case 3:
            monthBefore = moment().subtract(3, 'months')
            break
          case 6:
            monthBefore = moment().subtract(6, 'months')
            break
          case 12:
            monthBefore = moment().subtract(12, 'months')
            break

          default:
            break
        }

        thisday = moment(thisday).format('YYYY-MM-DD')
        let startDate = moment(monthBefore).format('YYYY-MM-DD')

        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'date_range',
          value,
        })
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'start',
          value: startDate,
        })
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'end',
          value: thisday,
        })
      }

      await this.$store.dispatch('vaStore/filterDate')
    },
    async choosedBisnisUnit(value) {
      let bisnis_unit = this.$store.state.vaStore.bisnis_unit
      if (value == bisnis_unit) {
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'bisnis_unit',
          value: '',
        })
      } else {
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'bisnis_unit',
          value,
        })

        switch (value) {
          case 'BCE':
            await this.getBcCompanyCode()
            break
          case 'GEMS':
            await this.getGemsCompanyCode()
            break
          case 'BKES':
            await this.getBkesCompanyCode()
            break
          default:
            break
        }
      }

      await this.$store.dispatch('vaStore/allFilter')
    },
    async choosedSIO(value) {
      let sio = this.$store.state.vaStore.sio
      if (value == sio) {
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'sio',
          value: '',
        })
      } else {
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'sio',
          value,
        })
      }

      await this.$store.dispatch('vaStore/allFilter')
    },
    async choosedAfiliasi(value) {
      let afiliasi = this.$store.state.vaStore.afiliasi
      if (value == afiliasi) {
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'afiliasi',
          value: '',
        })
      } else {
        await this.$store.commit('vaStore/UPDATE_DATA', {
          name: 'afiliasi',
          value,
        })
      }
      await this.$store.dispatch('vaStore/allFilter')
    },
    fixCompanyBC(value) {
      this.bcValue = value
    },
    fixCompanyGEMS(value) {
      this.gemsValue = value
    },
    async getKbli() {
      try {
        const url = `${api}/api/v1/kbli-parent?page=1&limit=2000`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.kbliList = await data.data.map(item => {
            return {
              id: `${item.id}`,
              label: `${item.desc}`,
            }
          })
        }
      } catch (error) {
        this.kbliList = []
      }
    },
    async getRegion() {
      try {
        const url = `${api}/api/v1/provinsi?page=1&limit=50`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.regions = await data.data.map(item => {
            return {
              id: item.id,
              label: `${item.desc}`,
            }
          })
        }
      } catch (error) {
        this.regions = []
      }
    },
    async getGemsCompanyCode() {
      this.company_options = []
    },
    async getBcCompanyCode() {
      try {
        const url = `${api}/api/v1/company-code-bc?page=1&limit=100`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.company_options = await data.data.map(item => {
            return {
              id: item.kode,
              label: `${item.kode} - ${item.nama_perusahaan}`,
            }
          })
        }
      } catch (error) {
        this.company_options = []
      }
    },
    async getBkesCompanyCode() {
      this.company_options = []
    },
  },
}
</script>
<style>
@media only screen and (max-width: 1024px) {
  .daterangepicker {
    min-width: 90vw !important;
  }
}

@media only screen and (max-width: 1366px) {
  .daterangepicker {
    min-width: 65vw !important;
  }
}

@media only screen and (min-width: 1367px) {
  .daterangepicker {
    min-width: 50vw !important;
  }
}

.vue-treeselect__multi-value-item {
  width: 100%;
  color: #c94f3c;
  background-color: rgba(128, 128, 128, 0.3);
}

.vue-treeselect__multi-value-label {
  font-size: 10px;
  max-width: 90px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.vue-treeselect__value-remove {
  color: #c94f3c;
}

.vue-treeselect__menu {
  z-index: 999999;
}
</style>
<style scoped>
.show-calendar {}

.range-picker-container {
  width: auto;
  height: auto;
  position: absolute;
  display: flex;
}

.slot {
  background-color: #aaa;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-black {
  color: #000;
}

.ranges {
  height: 35vh;
  overflow-y: auto;
}

.input-picker {
  width: 20%;
  border: 1px solid tomato;
}
</style>
